
const config = {
  // 是否是调试模式，true 为json数据，false为服务器数据
  isDebug: false
}
// 将当前时间转换成yyyymmddhhmmss格式
config.getDate = function () {
  const today = new Date()
  const year = today.getFullYear()
  const month = (today.getMonth() + 1) < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1
  const day = (today.getDate()) < 10 ? `0${today.getDate()}` : today.getDate()
  const hours = today.getHours() < 10 ? `0${today.getHours()}` : today.getHours()
  const minutes = today.getMinutes() < 10 ? `0${today.getMinutes()}` : today.getMinutes()
  const seconds = today.getSeconds() < 10 ? `0${today.getSeconds()}` : today.getSeconds()
  const now = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  return now
}
// token 加密
const CryptoJS = require('crypto-js')
config.decodeToken = function () {
  const _time = new Date().getTime()
  const _key = CryptoJS.enc.Utf8.parse(_time + 1000000000000000)
  let encryptedData = CryptoJS.AES.encrypt(localStorage.token === undefined ? '' : localStorage.token, _key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  encryptedData = encryptedData.ciphertext.toString()
  const encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedData)
  const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  // console.log(encryptedBase64Str)
  const obj = {
    token: encodeURIComponent(encryptedBase64Str),
    time: _time
  }
  return obj
}
/**
 * 前端分页
 * @param {数据*} dataArr
 * @param {一页多少个*} pageSize
 * return {返回一个被分成每项pageSize个的数组}
 */
config.getPage = function (dataArr, pageSize) {
  let result = []
  dataArr.forEach((item, index) => {
    if (index % pageSize === 0) {
      result.push([])
    }
    result[result.length - 1].push(item)
  })
  return result
}
//  获取url中的参数
config.getUrlParams = function () {
  const params = {}
  const paramsArr = window.location.href.split('?')[1].split('&')
  paramsArr.forEach(item => {
    const arr = item.split('=')
    params[arr[0]] = arr[1]
  })
  return params
}
const localPath = {

}
const servePath = {
  videoListurl: `/pxsp/videoList`,
  videoDetailurl: `/pxsp/videoDetail`,
  watch: `/pxsp/watch`
}
config.url = config.isDebug ? localPath : servePath
window.zvconfig = config



// WEBPACK FOOTER //
// ./src/js/config.js